import { STARTING_BACKGROUND_COLOR_PARAM_NAME } from './spaces';

export const parseBundleVersion = (indexHtmlContent) => {
  const match = indexHtmlContent.match(/main\.([a-f0-9]+)\.js/);
  return match ? match[1] : null;
};

export const checkUpdatedBundleVersion = async () => {
  const response = await fetch('/');
  if (response.ok) {
    console.log('App is online and body is available');
    const text = await response.text();
    const remoteBundleVersion = parseBundleVersion(text);
    // dispatch({
    //   type: 'APP_UPDATE_CHECKED',
    //   remoteBundleVersion,
    // });
    return remoteBundleVersion;
  }

  if (response.status === 304) {
    console.log('App is online and body is unchanged');
  } else {
    console.log(`App is offline. Response status ${response.status}`);
  }
  return null;
};

export const doesAppNeedUpdate = (remoteBundleVersion) => {
  if (!remoteBundleVersion) {
    return false;
  }
  const headText = document.head.innerHTML;
  const localBundleVersion = parseBundleVersion(headText);
  if (!localBundleVersion) {
    console.warn(
      `Failed to parse local bundle version, will not attempt update`,
    );
    return false;
  }
  console.log(
    `Local bundle version: ${localBundleVersion}, remote bundle version: ${remoteBundleVersion}`,
  );
  return localBundleVersion !== remoteBundleVersion;
};

export const refreshAppPreservingBackgroundColor = (backgroundColor) => {
  const oldLocation = new URL(document.location);
  const searchParams = oldLocation.searchParams || new URLSearchParams();
  if (backgroundColor) {
    searchParams.set(STARTING_BACKGROUND_COLOR_PARAM_NAME, backgroundColor);
  }
  const newUrl = `${oldLocation.origin}?${searchParams}`;
  window.location.replace(newUrl);
};
